<template>
    <div v-if="loading" class="flex justify-center items-center h-64">
        <div class="text-center">
            <i class="pi pi-spinner pi-spin text-4xl text-blue-500"></i>
            <p class="mt-4 text-gray-600">Loading roles...</p>
        </div>
    </div>
    
    <div v-else-if="error" class="flex justify-center items-center h-64">
        <div class="text-center">
            <i class="pi pi-exclamation-triangle text-4xl text-red-500"></i>
            <p class="mt-4 text-red-600">{{ error }}</p>
            <Button 
                label="Retry" 
                class="mt-4" 
                @click="get_user_role" 
                severity="secondary"
            />
        </div>
    </div>
    
    <div v-else-if="list_role.length === 0" class="flex justify-center items-center h-64">
        <div class="text-center">
            <i class="pi pi-user-times text-4xl text-gray-500"></i>
            <p class="mt-4 text-gray-600">No roles available for your account</p>
        </div>
    </div>
    
    <div v-else class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
        <Card v-for="(each_role, index) in list_role" :key="index" class="p-4 shadow-lg rounded-lg border border-gray-300 text-center flex flex-col items-center">
            <template #header>
                <div class="flex justify-center items-center">
                    <i :class="['pi', each_role.role.icon || 'pi-user']" class="text-6xl text-blue-500"></i>
                </div>
            </template>
            <template #title>
                <h3 class="text-lg font-semibold">{{ each_role.role_display_name || each_role.role.name }}</h3>
            </template>
            <template #footer>
                <Button 
                    icon="pi pi-check" 
                    class="w-full mt-3 bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600" 
                    @click="ubah_role(each_role)" 
                    label="Pilih" 
                    :loading="selectedRole === each_role"
                />
            </template>
        </Card>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { Inertia } from '@inertiajs/inertia';
import Card from "primevue/card";
import Button from "primevue/button";

const list_role = ref([]);
const loading = ref(true);
const error = ref(null);
const selectedRole = ref(null);

onMounted(() => {
    get_user_role();
});

function get_user_role() {
    loading.value = true;
    error.value = null;
    
    axios.get('/roles/get_user_role_view')
        .then(response => {
            if (response.data && response.data.data) {
                list_role.value = Object.values(response.data.data);
                
                // If user has only one role, automatically select it
                if (list_role.value.length === 1) {
                    setTimeout(() => {
                        ubah_role(list_role.value[0]);
                    }, 1000);
                }
            } else {
                error.value = 'Invalid response format from server';
            }
        })
        .catch(error => {
            console.error("Error fetching roles:", error);
            if (error.response) {
                error.value = `Server error: ${error.response.status} - ${error.response.data.message || 'Unknown error'}`;
            } else if (error.request) {
                error.value = 'Network error: Unable to connect to server';
            } else {
                error.value = 'An unexpected error occurred';
            }
        })
        .finally(() => {
            loading.value = false;
        });
}

function ubah_role(selected_role) {
    selectedRole.value = selected_role;
    
    Inertia.post(route('users.switch_session_role'), { 
        selected_role 
    }, {
        onFinish: () => {
            selectedRole.value = null;
        },
        onError: (errors) => {
            console.error('Role switch error:', errors);
            selectedRole.value = null;
        }
    });
}
</script>

<style scoped>
.text-6xl {
    font-size: 4rem;
}
</style>
